var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { spawn, all, fork } from 'redux-saga/effects';
import { formManagerWatcherSaga } from '../root-modules/form-manager-module';
import { initLoadManagerWatcherSaga } from '../root-modules/init-load-manager-module';
import { redirectManagerWatcherSaga } from '../root-modules/redirect-manager-module';
import { requestExtraDataHandlerWatcherSaga } from '../root-modules/request-extra-data-handler-module';
import { downloadFilesManagerWatcherSaga } from '../root-modules/download-files-manager';
import { getIsClient, injectAsyncSaga } from '../utils';
export var createRootSaga = function (_a) {
    var _b = _a.rootSagas, rootSagas = _b === void 0 ? {} : _b, router = _a.router, eventNameToCancelRequests = _a.eventNameToCancelRequests, store = _a.store;
    return function rootSaga() {
        var dispatch, isNode;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch = store.dispatch;
                    isNode = !getIsClient();
                    if (!isNode) return [3 /*break*/, 3];
                    // на сервере нам надо сделать процессы которые могут быть отслеживаемыми (fork)
                    // на клиенте нам надо сделать процессы которые могут быть неубиваемыми (spawn)
                    return [4 /*yield*/, all([
                            fork(downloadFilesManagerWatcherSaga, { dispatch: dispatch, store: store }),
                            fork(formManagerWatcherSaga, { dispatch: dispatch, store: store }),
                            fork(initLoadManagerWatcherSaga, {
                                eventNameToCancelRequests: eventNameToCancelRequests,
                                dispatch: dispatch,
                                store: store,
                            }),
                            fork(requestExtraDataHandlerWatcherSaga, { dispatch: dispatch, store: store }),
                            fork(redirectManagerWatcherSaga, { router: router, dispatch: dispatch }),
                        ])];
                case 1:
                    // на сервере нам надо сделать процессы которые могут быть отслеживаемыми (fork)
                    // на клиенте нам надо сделать процессы которые могут быть неубиваемыми (spawn)
                    _a.sent();
                    return [4 /*yield*/, all(Object.entries(rootSagas).map(function (_a) {
                            var _b = __read(_a, 2), name = _b[0], saga = _b[1];
                            return injectAsyncSaga({
                                saga: saga,
                                name: name,
                                store: store,
                                isRoot: true,
                            });
                        }))];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 11];
                case 3: return [4 /*yield*/, spawn(downloadFilesManagerWatcherSaga, { store: store, dispatch: dispatch })];
                case 4:
                    _a.sent();
                    return [4 /*yield*/, spawn(formManagerWatcherSaga, { store: store, dispatch: dispatch })];
                case 5:
                    _a.sent();
                    return [4 /*yield*/, spawn(initLoadManagerWatcherSaga, {
                            eventNameToCancelRequests: eventNameToCancelRequests,
                            dispatch: dispatch,
                            store: store,
                        })];
                case 6:
                    _a.sent();
                    return [4 /*yield*/, spawn(requestExtraDataHandlerWatcherSaga, { dispatch: dispatch, store: store })];
                case 7:
                    _a.sent();
                    if (!Boolean(router)) return [3 /*break*/, 9];
                    return [4 /*yield*/, spawn(redirectManagerWatcherSaga, { router: router, dispatch: dispatch })];
                case 8:
                    _a.sent();
                    _a.label = 9;
                case 9: 
                // run additional root sagas
                return [4 /*yield*/, all(Object.entries(rootSagas).map(function (_a) {
                        var _b = __read(_a, 2), name = _b[0], saga = _b[1];
                        return injectAsyncSaga({
                            saga: saga,
                            name: name,
                            store: store,
                            isRoot: true,
                        });
                    }))];
                case 10:
                    // run additional root sagas
                    _a.sent();
                    _a.label = 11;
                case 11: return [2 /*return*/];
            }
        });
    };
};
